import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const batchImportCallable = httpsCallable(functions, 'batchImportDirectory');

/**
 * Submit a batch import of families and members.
 * @param {Array<{surname: string, members: Array<{firstName: string, email: string|null}>}>} families
 * @returns {Promise<{success: boolean, familiesCreated: number, membersCreated: number}>}
 */
export async function batchImportDirectory(families) {
  const result = await batchImportCallable({ families });
  if (result.data?.success) {
    return result.data;
  }
  throw new Error(result.data?.message || 'Import failed');
}

const importService = { batchImportDirectory };
export default importService;
